<sc-padding fitHeight>
  <sc-flex vertical fitHeight stretchContent>
    <sc-title>
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.task-assignment-dialog.processing-hint.title"></sc-dictionary-label>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-icon iconClass="fa-times" (click)="close()"></sc-icon>
    </sc-title>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-flex-fitting-content vertical>
      <sc-scroll-pane>
        <div class="hint-text" [innerHTML]="data | trustHtml"></div>
      </sc-scroll-pane>
    </sc-flex-fitting-content>
  </sc-flex>
</sc-padding>
